import { ActionTypes } from "../constants";

const reduceAccomplishments = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_TMS_ACCOMPLISHMENTS_SUCCESS:
            return action.data;

        default:
            return state;
    }
};

export default reduceAccomplishments;
